// src/helpers/strToBool.ts
const TRUE_VALUES = new Set(['true', '1', 'on', 'yes', 'vrai', 'oui'])

export const strToBool = (s?: string, fallback = false): boolean =>
  s == null ? fallback : TRUE_VALUES.has(s.trim().toLowerCase())

/**
 * envToBool — reads from Vite's import.meta.env *or* process.env (Vue CLI / Node),
 * preferring Vite when both exist. Falls back to `fallback` if unset.
 */
export const envToBool = (name: string, fallback = false): boolean => {
  const viteEnv = (typeof import.meta !== 'undefined' ? (import.meta as any).env : undefined)
  const nodeEnv = (globalThis as any)?.process?.env as Record<string, unknown> | undefined

  const raw = (viteEnv && name in viteEnv)
    ? viteEnv[name]
    : (nodeEnv && name in nodeEnv)
        ? nodeEnv[name]
        : undefined

  return typeof raw === 'string'
    ? strToBool(raw, fallback)
    : typeof raw === 'boolean'
      ? raw
      : fallback
}

export const envToNumber = (name: string, fallback = 0): number => {
  const v = (typeof import.meta !== 'undefined' ? (import.meta as any).env?.[name] : undefined) ??
        (globalThis as any)?.process?.env?.[name]
  const n = Number(v)
  return Number.isFinite(n) ? n : fallback
}
